// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import MainTemplate from "../../custom_components/templates/MainTemplate.js";
// import { useUserPermission } from "custom_hooks/Actions.js";

// function Module6() {
//   const [hasCompletedQuiz, setHasCompletedQuiz] = useState(false);
//   const permission = useUserPermission(13);
//   const [showFinalResult, setFinalresult] = useState(false);
//   const [score, setScore] = useState(0);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [hasPass, setPass] = useState(false);
//   const [testResults, setTestResults] = useState([]);
//   const course_id = 6;
//   let finalscore = 1;
//   let fetchUrl = domain + "/api/EmployeeModule/";

//   if (showFinalResult) {
//     const data = JSON.stringify(course_id, score, hasPass);
//   }
//   const questions = [
//     {
//       test: "Purpose of Sea Water Intake is?",
//       inputname: "Q41",
//       options: [
//         { id: 0, text: "a) Inlet of Sea Water", isCorrect: true },
//         { id: 1, text: "b) Outlet of Sea water", isCorrect: false },
//       ],
//     },
//     {
//       test: "Purpose of Sea Water Discharge Culvert is?",
//       inputname: "Q42",
//       options: [
//         { id: 0, text: "a) Inlet of Sea Water", isCorrect: false },
//         { id: 1, text: "b) Outlet of Sea Water", isCorrect: true },
//       ],
//     },
//     {
//       test: "Construction of Sea Water Intake required?",
//       inputname: "Q43",
//       options: [
//         { id: 0, text: "a) Deep Excavation", isCorrect: true },
//         {
//           id: 1,
//           text: "b) ERSS (Earth Retaining Stabilizing Structure)",
//           isCorrect: true,
//         },
//         { id: 2, text: "c) ECM (Erosion Control Measure)", isCorrect: true },
//       ],
//     },
//     {
//       test: "Shoring for Deep Excavation, can use with?",
//       inputname: "Q44",
//       options: [
//         { id: 0, text: "a) Sheet Piling", isCorrect: false },
//         { id: 1, text: "b) Bored Piling", isCorrect: false },
//         { id: 2, text: "c) As per PE (Design requirement)", isCorrect: true },
//       ],
//     },
//     {
//       test: "Working at Deep excavated pit, required with?",
//       inputname: "Q45",
//       options: [
//         { id: 0, text: "a) Sufficient light", isCorrect: true },
//         { id: 1, text: "b) Sufficient Ventilation System", isCorrect: true },
//         { id: 2, text: "c) Emergency Access", isCorrect: true },
//       ],
//     },
//     {
//       test: "For Dredging area, must clear with?",
//       inputname: "Q46",
//       options: [
//         { id: 0, text: "a) Underwater pipe", isCorrect: true },
//         { id: 1, text: "b) Underwater Power line", isCorrect: true },
//         {
//           id: 2,
//           text: "c) Underwater Cable and communication line",
//           isCorrect: true,
//         },
//       ],
//     },
//     {
//       test: "Installation of GRP (Glass Reinforced Plastic) Pipe at underwater, required with?",
//       inputname: "Q47",
//       options: [
//         { id: 0, text: "a) Dredging work", isCorrect: true },
//         { id: 1, text: "b) Lifting Work", isCorrect: true },
//         { id: 2, text: "c) Diving and installing Work", isCorrect: true },
//       ],
//     },
//     {
//       test: "Dredging work can perform with?",
//       inputname: "Q48",
//       options: [
//         { id: 0, text: "a) Dredger", isCorrect: true },
//         {
//           id: 1,
//           text: "b) Long Arm Excavator with Floating Barge",
//           isCorrect: true,
//         },
//       ],
//     },
//     {
//       test: "Installation of Intake Head at underwater required with?",
//       inputname: "Q49",
//       options: [
//         { id: 0, text: "a) Dredging work", isCorrect: true },
//         { id: 1, text: "b) Lifting work", isCorrect: true },
//         { id: 2, text: "c) Diving and installing work", isCorrect: true },
//       ],
//     },
//     {
//       test: "Construction of Sea Water Discharge Culvert (Outfall) required with?",
//       inputname: "Q50",
//       options: [
//         { id: 0, text: "a) Piling work", isCorrect: true },
//         { id: 1, text: "b) ERSS", isCorrect: true },
//         { id: 2, text: "c) Concrete structure work", isCorrect: true },
//       ],
//     },
//     // ...
//   ];

//   // helper
//   const optionClicked = (isCorrect) => {
//     if (isCorrect) {
//       setScore((prevScore) => prevScore + 1);
//     }
//     if (currentQuestion + 1 < questions.length) {
//       setCurrentQuestion(currentQuestion + 1);
//     } else {
//       setFinalresult(true);
//       // Calculate whether the user has passed the test based on the score
//       const hasPassed = score > 6; // Adjust the passing score threshold as needed
//       console.log(hasPassed);
//       setPass(hasPassed); // Set the hasPass state
//       // Add the current test result to the testResults array
//       const result = {
//         course_id: course_id,
//         finalscore: score + 1,
//         hasPass: hasPassed ? "Pass" : "Fail",
//       };
//       setTestResults((prevResults) => [...prevResults, result]);
//     }
//   };
//   useEffect(() => {
//     // Define a function to handle the AJAX request
//     const fetchDataFromServer = async () => {
//       try {
//         if (testResults.length > 0) {
//           const response = await fetch(
//             domain + "/api/E-Learning/Elearning.php",
//             {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({ data: testResults }),
//             }
//           );

//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }

//           const data = await response.text();
//           // Handle the response from the server if needed
//           console.log(data);
//         }
//       } catch (error) {
//         // Handle any errors that occur during the AJAX request
//         console.error("Error:", error);
//       }
//     };

//     // Call the fetchDataFromServer function
//     fetchDataFromServer();
//   }, [testResults]);
//   return (
//     <MainTemplate
//       content={
//         <Router>
//           <div className="Module1test">
//             <h1>Module 1 & 2 Test</h1>
//             <h2>Current Score: {score} </h2>
//             {showFinalResult ? (
//               <div className="Final Result">
//                 <h1>Final Result</h1>
//                 <h2>
//                   {score} out of {questions.length} is correct-
//                   {(score / questions.length) * 100}%
//                 </h2>
//                 <h3 className="Passfail">
//                   {hasPass ? (
//                     <h3>You Have pass your test</h3>
//                   ) : (
//                     <h3>You have failed your test</h3>
//                   )}
//                 </h3>
//                 <button>Main page</button>
//               </div>
//             ) : (
//               <div className="Question-list">
//                 <h2 className="Question-text">
//                   Question {currentQuestion + 1} out of {questions.length}
//                 </h2>
//                 <h3 className="Question-text">
//                   {questions[currentQuestion].test}
//                 </h3>

//                 <ul>
//                   {questions[currentQuestion].options.map((option) => {
//                     return (
//                       <li
//                         onClick={() => optionClicked(option.isCorrect)}
//                         key={option.id}
//                       >
//                         {option.text}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             )}
//           </div>

//           <Switch>
//             {permission.add && <Route path="/:subdom/:page/:module6" />}
//           </Switch>
//         </Router>
//       }
//     />
//   );
// }

// export default Module6;

// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import MainTemplate from "../../custom_components/templates/MainTemplate.js";
// import { useUserPermission } from "custom_hooks/Actions.js";

// function Module5() {
//   const [hasCompletedQuiz, setHasCompletedQuiz] = useState(false);
//   const permission = useUserPermission(13);
//   const [showFinalResult, setFinalresult] = useState(false);
//   const [score, setScore] = useState(0);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [hasPass, setPass] = useState(false);
//   const [testResults, setTestResults] = useState([]);
//   const course_id = 5;
//   let finalscore = 1;
//   let fetchUrl = domain + "/api/EmployeeModule/";

//   if (showFinalResult) {
//     const data = JSON.stringify(course_id, score, hasPass);
//   }
//   const questions = [
//     // Previous questions (including the 4th session questions)
//     // ...

//     {
//       test: "Construction of Jetty’s pile, used with?",
//       inputname: "Q31",
//       options: [
//         { id: 0, text: "a) Spun Pile", isCorrect: true },
//         { id: 1, text: "b) Steel Pipe Pile", isCorrect: true },
//       ],
//     },
//     {
//       test: "Driving of large pile with huge quantities, which equipment is suitable?",
//       inputname: "Q32",
//       options: [
//         { id: 0, text: "a) Crane barge", isCorrect: false },
//         { id: 1, text: "b) Piling barge", isCorrect: true },
//       ],
//     },
//     {
//       test: "Pile driving for normal size with small quantities, which equipment is suitable?",
//       inputname: "Q33",
//       options: [
//         { id: 0, text: "a) Crane barge", isCorrect: true },
//         { id: 1, text: "b) Piling barge", isCorrect: false },
//       ],
//     },
//     {
//       test: "For Crane barge method, for first pitching and driving of pile, which equipment to use?",
//       inputname: "Q34",
//       options: [
//         { id: 0, text: "a) Vibro-hammer", isCorrect: true },
//         { id: 1, text: "b) Hydraulic hammer", isCorrect: false },
//       ],
//     },
//     {
//       test: "For Crane barge method, for driving & setting of steel pile, which equipment to use?",
//       inputname: "Q35",
//       options: [
//         { id: 0, text: "a) Vibro-hammer", isCorrect: false },
//         { id: 1, text: "b) Hydraulic hammer", isCorrect: true },
//       ],
//     },
//     {
//       test: "Raked pile use for which position?",
//       inputname: "Q36",
//       options: [
//         { id: 0, text: "a) Vertical", isCorrect: false },
//         { id: 1, text: "b) Inclined", isCorrect: true },
//       ],
//     },
//     {
//       test: "Which test can perform for blow count and maximum compression and tension stress of pile?",
//       inputname: "Q37",
//       options: [
//         { id: 0, text: "a) PDA (Pile Driving Analysis)", isCorrect: true },
//         { id: 1, text: "b) Static load test", isCorrect: false },
//       ],
//     },
//     {
//       test: "Which test can perform for design requirement load test?",
//       inputname: "Q38",
//       options: [
//         { id: 0, text: "a) PDA (Pile Driving Analysis)", isCorrect: false },
//         { id: 1, text: "b) Static load test", isCorrect: true },
//       ],
//     },
//     {
//       test: "Anode will prevent Steel structure from?",
//       inputname: "Q39",
//       options: [
//         { id: 0, text: "a) Corrosion", isCorrect: true },
//         { id: 1, text: "b) Electrocution", isCorrect: false },
//       ],
//     },
//     {
//       test: "Underdeck painting will increase and prevent from?",
//       inputname: "Q40",
//       options: [
//         { id: 0, text: "a) Durability of Concrete Deck", isCorrect: true },
//         { id: 1, text: "b) Corrosion of Rebar", isCorrect: true },
//       ],
//     },
//     // ...
//   ];

//   // helper
//   const optionClicked = (isCorrect) => {
//     if (isCorrect) {
//       setScore((prevScore) => prevScore + 1);
//     }
//     if (currentQuestion + 1 < questions.length) {
//       setCurrentQuestion(currentQuestion + 1);
//     } else {
//       setFinalresult(true);
//       // Calculate whether the user has passed the test based on the score
//       const hasPassed = score > 6; // Adjust the passing score threshold as needed
//       console.log(hasPassed);
//       setPass(hasPassed); // Set the hasPass state
//       // Add the current test result to the testResults array
//       const result = {
//         course_id: course_id,
//         finalscore: score + 1,
//         hasPass: hasPassed ? "Pass" : "Fail",
//       };
//       setTestResults((prevResults) => [...prevResults, result]);
//     }
//   };
//   useEffect(() => {
//     // Define a function to handle the AJAX request
//     const fetchDataFromServer = async () => {
//       try {
//         if (testResults.length > 0) {
//           const response = await fetch(
//             domain + "/api/E-Learning/Elearning.php",
//             {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({ data: testResults }),
//             }
//           );

//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }

//           const data = await response.text();
//           // Handle the response from the server if needed
//           console.log(data);
//         }
//       } catch (error) {
//         // Handle any errors that occur during the AJAX request
//         console.error("Error:", error);
//       }
//     };

//     // Call the fetchDataFromServer function
//     fetchDataFromServer();
//   }, [testResults]);
//   return (
//     <MainTemplate
//       content={
//         <Router>
//           <div className="Module1test">
//             <h1>Module 1 & 2 Test</h1>
//             <h2>Current Score: {score} </h2>
//             {showFinalResult ? (
//               <div className="Final Result">
//                 <h1>Final Result</h1>
//                 <h2>
//                   {score} out of {questions.length} is correct-
//                   {(score / questions.length) * 100}%
//                 </h2>
//                 <h3 className="Passfail">
//                   {hasPass ? (
//                     <h3>You Have pass your test</h3>
//                   ) : (
//                     <h3>You have failed your test</h3>
//                   )}
//                 </h3>
//                 <button>Main page</button>
//               </div>
//             ) : (
//               <div className="Question-list">
//                 <h2 className="Question-text">
//                   Question {currentQuestion + 1} out of {questions.length}
//                 </h2>
//                 <h3 className="Question-text">
//                   {questions[currentQuestion].test}
//                 </h3>

//                 <ul>
//                   {questions[currentQuestion].options.map((option) => {
//                     return (
//                       <li
//                         onClick={() => optionClicked(option.isCorrect)}
//                         key={option.id}
//                       >
//                         {option.text}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             )}
//           </div>

//           <Switch>
//             {permission.add && <Route path="/:subdom/:page/:module5" />}
//           </Switch>
//         </Router>
//       }
//     />
//   );
// }

// export default Module5;

// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import MainTemplate from "../../custom_components/templates/MainTemplate.js";
// import { useUserPermission } from "custom_hooks/Actions.js";

// function Module4() {
//   const [hasCompletedQuiz, setHasCompletedQuiz] = useState(false);
//   const permission = useUserPermission(13);
//   const [showFinalResult, setFinalresult] = useState(false);
//   const [score, setScore] = useState(0);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [hasPass, setPass] = useState(false);
//   const [testResults, setTestResults] = useState([]);
//   const course_id = 4;
//   let finalscore = 1;
//   let fetchUrl = domain + "/api/EmployeeModule/";

//   if (showFinalResult) {
//     const data = JSON.stringify(course_id, score, hasPass);
//   }
//   const questions = [
//     // Previous questions
//     // ...

//     {
//       test: "RC Pile use for which construction?",
//       inputname: "Q21",
//       options: [
//         { id: 0, text: "a) Jetty only", isCorrect: false },
//         { id: 1, text: "b) Building only", isCorrect: false },
//         {
//           id: 2,
//           text: "c) Foundation for all types of Engineering Structure",
//           isCorrect: true,
//         },
//       ],
//     },
//     {
//       test: "Spun Pile produce with?",
//       inputname: "Q22",
//       options: [
//         { id: 0, text: "a) Cast In-situ", isCorrect: false },
//         { id: 1, text: "b) Precast", isCorrect: false },
//         { id: 2, text: "c) Prestressed Concrete", isCorrect: true },
//       ],
//     },
//     {
//       test: "Spun Pile Piling commonly used for?",
//       inputname: "Q23",
//       options: [
//         { id: 0, text: "a) Tall building", isCorrect: false },
//         {
//           id: 1,
//           text: "b) Special conditions such as river, marine, or high chloride soil",
//           isCorrect: true,
//         },
//       ],
//     },
//     {
//       test: "Jack in Piling system use with?",
//       inputname: "Q24",
//       options: [
//         { id: 0, text: "a) Hydraulic Hammer", isCorrect: false },
//         {
//           id: 1,
//           text: "b) Dead weight used and insert pressure to drive pile into the ground",
//           isCorrect: true,
//         },
//         { id: 2, text: "c) Vibro-hammer", isCorrect: false },
//       ],
//     },
//     {
//       test: "Jack-in Piling commonly used for?",
//       inputname: "Q25",
//       options: [
//         { id: 0, text: "a) Marine Building", isCorrect: false },
//         {
//           id: 1,
//           text: "b) Medium loaded structures such as residential or commercial building",
//           isCorrect: true,
//         },
//         { id: 2, text: "c) Bridge", isCorrect: false },
//       ],
//     },
//     {
//       test: "Micro pile size is?",
//       inputname: "Q26",
//       options: [
//         { id: 0, text: "a) Large diameter", isCorrect: false },
//         { id: 1, text: "b) Small diameter", isCorrect: true },
//       ],
//     },
//     {
//       test: "Bored Pile produce with?",
//       inputname: "Q27",
//       options: [
//         { id: 0, text: "a) Precast", isCorrect: false },
//         { id: 1, text: "b) Cast-in-place (Cast on site)", isCorrect: true },
//         { id: 2, text: "c) Prestressed", isCorrect: false },
//       ],
//     },
//     {
//       test: "Bored Pile commonly used for?",
//       inputname: "Q28",
//       options: [
//         {
//           id: 0,
//           text: "a) Bridge, tall building, and massive industrial complex, required deep foundation",
//           isCorrect: true,
//         },
//         { id: 1, text: "b) Small building", isCorrect: false },
//       ],
//     },
//     {
//       test: "Steel Pipe Pile commonly used for?",
//       inputname: "Q29",
//       options: [
//         { id: 0, text: "a) Tall building", isCorrect: false },
//         { id: 1, text: "b) Bridge, building and wharves.", isCorrect: true },
//         { id: 2, text: "c) Machine Foundation", isCorrect: false },
//       ],
//     },
//     {
//       test: "RCD (Reverse Circulation Drilling) used for?",
//       inputname: "Q30",
//       options: [
//         { id: 0, text: "a) Soft soil", isCorrect: false },
//         { id: 1, text: "b) Rock and hard layer", isCorrect: true },
//       ],
//     },
//     // ...
//   ];

//   // helper
//   const optionClicked = (isCorrect) => {
//     if (isCorrect) {
//       setScore((prevScore) => prevScore + 1);
//     }
//     if (currentQuestion + 1 < questions.length) {
//       setCurrentQuestion(currentQuestion + 1);
//     } else {
//       setFinalresult(true);
//       // Calculate whether the user has passed the test based on the score
//       const hasPassed = score > 6; // Adjust the passing score threshold as needed
//       console.log(hasPassed);
//       setPass(hasPassed); // Set the hasPass state
//       // Add the current test result to the testResults array
//       const result = {
//         course_id: course_id,
//         finalscore: score + 1,
//         hasPass: hasPassed ? "Pass" : "Fail",
//       };
//       setTestResults((prevResults) => [...prevResults, result]);
//     }
//   };
//   useEffect(() => {
//     // Define a function to handle the AJAX request
//     const fetchDataFromServer = async () => {
//       try {
//         if (testResults.length > 0) {
//           const response = await fetch(
//             domain + "/api/E-Learning/Elearning.php",
//             {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({ data: testResults }),
//             }
//           );

//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }

//           const data = await response.text();
//           // Handle the response from the server if needed
//           console.log(data);
//         }
//       } catch (error) {
//         // Handle any errors that occur during the AJAX request
//         console.error("Error:", error);
//       }
//     };

//     // Call the fetchDataFromServer function
//     fetchDataFromServer();
//   }, [testResults]);
//   return (
//     <MainTemplate
//       content={
//         <Router>
//           <div className="Module1test">
//             <h1>Module 1 & 2 Test</h1>
//             <h2>Current Score: {score} </h2>
//             {showFinalResult ? (
//               <div className="Final Result">
//                 <h1>Final Result</h1>
//                 <h2>
//                   {score} out of {questions.length} is correct-
//                   {(score / questions.length) * 100}%
//                 </h2>
//                 <h3 className="Passfail">
//                   {hasPass ? (
//                     <h3>You Have pass your test</h3>
//                   ) : (
//                     <h3>You have failed your test</h3>
//                   )}
//                 </h3>
//                 <button>Main page</button>
//               </div>
//             ) : (
//               <div className="Question-list">
//                 <h2 className="Question-text">
//                   Question {currentQuestion + 1} out of {questions.length}
//                 </h2>
//                 <h3 className="Question-text">
//                   {questions[currentQuestion].test}
//                 </h3>

//                 <ul>
//                   {questions[currentQuestion].options.map((option) => {
//                     return (
//                       <li
//                         onClick={() => optionClicked(option.isCorrect)}
//                         key={option.id}
//                       >
//                         {option.text}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             )}
//           </div>

//           <Switch>
//             {permission.add && <Route path="/:subdom/:page/:module4" />}
//           </Switch>
//         </Router>
//       }
//     />
//   );
// }

// export default Module4;


// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// import MainTemplate from "../../custom_components/templates/MainTemplate.js";
// import { useUserPermission } from "custom_hooks/Actions.js";

// function Module3() {
//   const [hasCompletedQuiz, setHasCompletedQuiz] = useState(false);
//   const permission = useUserPermission(13);
//   const [showFinalResult, setFinalresult] = useState(false);
//   const [score, setScore] = useState(0);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [hasPass, setPass] = useState(false);
//   const [testResults, setTestResults] = useState([]);
//   const course_id = 3;
//   let finalscore = 1;
//   let fetchUrl = domain + "/api/EmployeeModule/";

//   if (showFinalResult) {
//     const data = JSON.stringify(course_id, score, hasPass);
//   }
//   const questions = [
//     {
//       test: "Performance value will be greater if Rubber Cone Fender size is?",
//       inputname: "Q11",
//       options: [
//         { id: 0, text: "a) Bigger", isCorrect: true },
//         { id: 1, text: "b) Smaller", isCorrect: false },
//       ],
//     },
//     {
//       test: "Fender front panel Polyethylene (PE) sliding plate is?",
//       inputname: "Q12",
//       options: [
//         { id: 0, text: "a) Fixed & not replaceable", isCorrect: false },
//         { id: 1, text: "b) Bolted & replaceable", isCorrect: true },
//       ],
//     },
//     {
//       test: "Which chain is used to support the weight of frontal and face panel?",
//       inputname: "Q13",
//       options: [
//         { id: 0, text: "a) Tension chain", isCorrect: false },
//         { id: 1, text: "b) Weight chain", isCorrect: true },
//         { id: 2, text: "c) Shear chain", isCorrect: false },
//       ],
//     },
//     {
//       test: "Which chain is to protect fender from damage while in shear deflection?",
//       inputname: "Q14",
//       options: [
//         { id: 0, text: "a) Tension chain", isCorrect: false },
//         { id: 1, text: "b) Weight chain", isCorrect: false },
//         { id: 2, text: "c) Shear chain", isCorrect: true },
//       ],
//     },
//     {
//       test: "When Install Fender Anchor Bolts at Jetty Concrete Deck, follow with which method?",
//       inputname: "Q15",
//       options: [
//         {
//           id: 0,
//           text: "a) In-situ cast with anchor and jetty concrete deck",
//           isCorrect: true,
//         },
//         {
//           id: 1,
//           text: "b) Drill to jetty concrete deck and install anchor bolt with epoxy.",
//           isCorrect: true,
//         },
//       ],
//     },
//     {
//       test: "Causes of damage to Jetty underdeck are?",
//       inputname: "Q16",
//       options: [
//         {
//           id: 0,
//           text: "a) Poor concrete quality & insufficient concrete cover",
//           isCorrect: true,
//         },
//         { id: 1, text: "b) Chloride penetration", isCorrect: true },
//         { id: 2, text: "c) Aging of concrete", isCorrect: true },
//       ],
//     },
//     {
//       test: "Chloride penetrated to Jetty Concrete Deck lead to?",
//       inputname: "Q17",
//       options: [
//         { id: 0, text: "a) Rebar corrosion", isCorrect: true },
//         { id: 1, text: "b) Spalling Concrete", isCorrect: true },
//         { id: 2, text: "c) Damaged Jetty underdeck", isCorrect: true },
//       ],
//     },
//     {
//       test: "Repairing of steel pile with coupler process, included with?",
//       inputname: "Q18",
//       options: [
//         {
//           id: 0,
//           text: "a) Blasting, power brushing to corroded steel pile",
//           isCorrect: true,
//         },
//         {
//           id: 1,
//           text: "b) Cover with steel pipe coupler and welding",
//           isCorrect: true,
//         },
//         { id: 2, text: "c) Painting", isCorrect: true },
//       ],
//     },
//     {
//       test: "Pile wrapping, pile jacketing & splash zone protection process included with?",
//       inputname: "Q19",
//       options: [
//         {
//           id: 0,
//           text: "a) Blasting, power brushing and cleaning of existing steel pile",
//           isCorrect: true,
//         },
//         {
//           id: 1,
//           text: "b) Apply primer and wrapping with tape",
//           isCorrect: true,
//         },
//         {
//           id: 2,
//           text: "c) Cover and jacket with heavy-duty pile wrapping material, tighten with SS bolt & nut",
//           isCorrect: true,
//         },
//       ],
//     },
//     {
//       test: "When calculating the length of pile wrapping, need to consider with?",
//       inputname: "Q20",
//       options: [
//         { id: 0, text: "a) MHWS (Mean High Water Spring)", isCorrect: true },
//         { id: 1, text: "b) LAT (Lowest Astronomical Tide)", isCorrect: true },
//       ],
//     },
//   ];
//   // helper
//   const optionClicked = (isCorrect) => {
//     if (isCorrect) {
//       setScore((prevScore) => prevScore + 1);
//     }
//     if (currentQuestion + 1 < questions.length) {
//       setCurrentQuestion(currentQuestion + 1);
//     } else {
//       setFinalresult(true);
//       // Calculate whether the user has passed the test based on the score
//       const hasPassed = score >= 6; // Adjust the passing score threshold as needed
//       console.log(hasPassed);
//       setPass(hasPassed); // Set the hasPass state
//       // Add the current test result to the testResults array
//       const result = {
//         course_id: course_id,
//         finalscore: score + 1,
//         hasPass: hasPassed ? "Pass" : "Fail",
//       };
//       setTestResults((prevResults) => [...prevResults, result]);
//     }
//   };
//   useEffect(() => {
//     // Define a function to handle the AJAX request
//     const fetchDataFromServer = async () => {
//       try {
//         if (testResults.length > 0) {
//           const response = await fetch(
//             domain + "/api/E-Learning/Elearning.php",
//             {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({ data: testResults }),
//             }
//           );

//           if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//           }

//           const data = await response.text();
//           // Handle the response from the server if needed
//           console.log(data);
//         }
//       } catch (error) {
//         // Handle any errors that occur during the AJAX request
//         console.error("Error:", error);
//       }
//     };

//     // Call the fetchDataFromServer function
//     fetchDataFromServer();
//   }, [testResults]);
//   return (
//     <MainTemplate
//       content={
//         <Router>
//           <div className="Module1test">
//             <h1>Module 1 & 2 Test</h1>
//             <h2>Current Score: {score} </h2>
//             {showFinalResult ? (
//               <div className="Final Result">
//                 <h1>Final Result</h1>
//                 <h2>
//                   {score} out of {questions.length} is correct-
//                   {(score / questions.length) * 100}%
//                 </h2>
//                 <h3 className="Passfail">
//                   {hasPass ? (
//                     <h3>You Have pass your test</h3>
//                   ) : (
//                     <h3>You have failed your test</h3>
//                   )}
//                 </h3>
//                 <button>Main page</button>
//               </div>
//             ) : (
//               <div className="Question-list">
//                 <h2 className="Question-text">
//                   Question {currentQuestion + 1} out of {questions.length}
//                 </h2>
//                 <h3 className="Question-text">
//                   {questions[currentQuestion].test}
//                 </h3>

//                 <ul>
//                   {questions[currentQuestion].options.map((option) => {
//                     return (
//                       <li
//                         onClick={() => optionClicked(option.isCorrect)}
//                         key={option.id}
//                       >
//                         {option.text}
//                       </li>
//                     );
//                   })}
//                 </ul>
//               </div>
//             )}
//           </div>

//           <Switch>
//             {permission.add && <Route path="/:subdom/:page/:module3" />}
//           </Switch>
//         </Router>
//       }
//     />
//   );
// }

// export default Module3;

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route,Link ,useHistory } from "react-router-dom";
import MainTemplate from "../../custom_components/templates/MainTemplate.js";
import { useFetchPost,useUserPermission } from "custom_hooks/Actions.js";
import ReactPlayer from "react-player";
import samplevideo from "../video/sample-video.mp4";


function Module6() {
  const path = process.env.REACT_APP_PATH;
  const domain = process.env.REACT_APP_DOMAIN
  let history = useHistory();
  const [hasCompletedQuiz, setHasCompletedQuiz] = useState(false);
  const permission = useUserPermission(13);
  const [showFinalResult, setFinalresult] = useState(false);
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [hasPass, setPass] = useState(false);
  const [testResults, setTestResults] = useState([]);
  const [progress, setProgress] = useState(0);
  const [count, setCount] = useState(0);
  const [validation, setValidation] = useState(true);
  const [videoPlay, setVideoPlay] = useState(true);
  const [tempResult, setTempResult] = useState({
    qus0 : '',
    qus1 : '',
    qus2 : '',
    qus3 : '',
    qus4 : '',
    qus5 : '',
    qus6 : '',
    qus7 : '',
    qus8 : '',
    qus9 : '',
   
  });
  const course_id = 6;
  const passCourseList = useFetchPost(
    domain + "/api/E-Learning/elearningUtility.php",
    { option: "option" }
  ).data;

  if(passCourseList.includes(6)){
    history.push(path + "/Module")
  }

  if (showFinalResult) {
    const data = JSON.stringify(course_id, score, hasPass);
  }
  const questions = [
        {
          test: "Q1 : Purpose of Sea Water Intake is?",
          inputname: "Q41",
          options: [
            { id: 0, serial: "a)", text: "Inlet of Sea Water", isCorrect: true },
            { id: 1, serial: "b)",text: "b) Outlet of Sea water", isCorrect: false },
          ],
        },
        {
          test: "Q2 : Purpose of Sea Water Discharge Culvert is?",
          inputname: "Q42",
          options: [
            { id: 0, serial: "a)",text: "Inlet of Sea Water", isCorrect: false },
            { id: 1, serial: "b)",text: "Outlet of Sea Water", isCorrect: true },
          ],
        },
        {
          test: "Q3 : Construction of Sea Water Intake required?",
          inputname: "Q43",
          options: [
            { id: 0, serial: "a)",text: "Deep Excavation", isCorrect: true },
            {
              id: 1,
              serial: "b)",
              text: "ERSS (Earth Retaining Stabilizing Structure)",
              isCorrect: true,
            },
            { id: 2, serial: "c)", text: "ECM (Erosion Control Measure)", isCorrect: true },
          ],
        },
        {
          test: "Q4 : Shoring for Deep Excavation, can use with?",
          inputname: "Q44",
          options: [
            { id: 0, serial: "a)", text: "Sheet Piling", isCorrect: false },
            { id: 1, serial: "b)",text: "Bored Piling", isCorrect: false },
            { id: 2, serial: "c)",text: "As per PE (Design requirement)", isCorrect: true },
          ],
        },
        {
          test: "Q5 : Working at Deep excavated pit, required with?",
          inputname: "Q45",
          options: [
            { id: 0, serial: "a)", text: "Sufficient light", isCorrect: true },
            { id: 1, serial: "b)", text: "Sufficient Ventilation System", isCorrect: true },
            { id: 2, serial: "c)",text: "Emergency Access", isCorrect: true },
          ],
        },
        {
          test: "Q6 : For Dredging area, must clear with?",
          inputname: "Q46",
          options: [
            { id: 0, serial: "a)", text: "Underwater pipe", isCorrect: true },
            { id: 1, serial: "b)", text: "Underwater Power line", isCorrect: true },
            {
              id: 2,
              serial: "c)",
              text: "Underwater Cable and communication line",
              isCorrect: true,
            },
          ],
        },
        {
          test: "Q7 : Installation of GRP (Glass Reinforced Plastic) Pipe at underwater, required with?",
          inputname: "Q47",
          options: [
            { id: 0, serial: "a)", text: "Dredging work", isCorrect: true },
            { id: 1, serial: "b)", text: "Lifting Work", isCorrect: true },
            { id: 2, serial: "c)", text: "Diving and installing Work", isCorrect: true },
          ],
        },
        {
          test: "Q8 : Dredging work can perform with?",
          inputname: "Q48",
          options: [
            { id: 0, serial: "a)", text: "Dredger", isCorrect: true },
            {
              id: 1,
              serial: "b)",
              text: "Long Arm Excavator with Floating Barge",
              isCorrect: true,
            },
          ],
        },
        {
          test: "Q9 : Installation of Intake Head at underwater required with?",
          inputname: "Q49",
          options: [
            { id: 0, serial: "a)", text: "Dredging work", isCorrect: true },
            { id: 1, serial: "b)", text: "Lifting work", isCorrect: true },
            { id: 2, serial: "c)", text: "Diving and installing work", isCorrect: true },
          ],
        },
        {
          test: "Q10 : Construction of Sea Water Discharge Culvert (Outfall) required with?",
          inputname: "Q50",
          options: [
            { id: 0, serial: "a)", text: "Piling work", isCorrect: true },
            { id: 1, serial: "b)", text: "ERSS", isCorrect: true },
            { id: 2, serial: "c)", text: "Concrete structure work", isCorrect: true },
          ],
        },
        // ...
      ];

  const videoNextClicked= () =>{
    
    setVideoPlay(false);
    setCount(count );

    if(currentQuestion <= questions.length ) {
      
      setCurrentQuestion(currentQuestion);
    }

    if(validation === false && tempResult['qus' + (currentQuestion)] === "" && (progress < (currentQuestion) * 10)){
      if (progress < 100) {
        setProgress(progress );
      } 
    }
  }

  const nextClicked= () =>{

      if(tempResult['qus' + (currentQuestion+1)]  === ""){
        setValidation(true);
      }else{
        setValidation(false);
      }
      
      if(count === 9){
        if (progress < 100) {
          setProgress(progress + 10);
        } 
     
        setFinalresult(true);
        // Calculate whether the user has passed the test based on the score
        const hasPassed = score >= 8; // Adjust the passing score threshold as needed
        
        setPass(hasPassed); // Set the hasPass state
        // Add the current test result to the testResults array
        const result = {
          course_id: course_id,
          finalscore: score,
          hasPass: hasPassed ? "Pass" : "Fail",
        };
        setTestResults((prevResults) => [...prevResults, result]);
      }else{
       
        setCount(count + 1);

        if(currentQuestion + 1 <= questions.length ) {
          
          setCurrentQuestion(currentQuestion + 1);
        }

        if(validation === false && tempResult['qus' + (currentQuestion+1)] === "" && (progress < (currentQuestion+1) * 10)){
          if (progress < 100) {
            setProgress(progress + 10);
          } 
        }
      }
  };

  const backClicked= () =>{
   
    if(count === 0){
      setVideoPlay(true);
      setCurrentQuestion(0);
    }else{
      setValidation(false);
      setCount(count - 1);
      if(currentQuestion - 1 <= questions.length) {
          setCurrentQuestion(currentQuestion - 1);
      }
    }
  
};

  const submitClicked = () =>{
    setFinalresult(true);
    // Calculate whether the user has passed the test based on the score
    const hasPassed = score >= 8; // Adjust the passing score threshold as needed
    setPass(hasPassed); // Set the hasPass state
    // Add the current test result to the testResults array
    const result = {
      course_id: course_id,
      finalscore: score + 1,
      hasPass: hasPassed ? "Pass" : "Fail",
    };
    setTestResults((prevResults) => [...prevResults, result]);
  };
 
  const optionClicked = (isCorrect,option_id,question_id) => {
    setValidation(false);
    setTempResult((prevState) => ({
      ...prevState,
      [question_id]: option_id,
    }));

    if (isCorrect) {
      setScore((prevScore) => prevScore + 1);
    }
    
    // if (currentQuestion + 1 <= questions.length) {
    //   setCurrentQuestion(currentQuestion + 1);
    // }
  };
  useEffect(() => {
    
    // Define a function to handle the AJAX request
    const fetchDataFromServer = async () => {
      try {
        if (testResults.length > 0) {
         
          const response = await fetch(
            domain + "/api/E-Learning/Elearning.php?action=module",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ data: testResults }),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.text();
          // Handle the response from the server if needed
          console.log(data);
        }
      } catch (error) {
        // Handle any errors that occur during the AJAX request
        console.error("Error:", error);
      }
    };

    // Call the fetchDataFromServer function
    fetchDataFromServer();
  }, [testResults]);
  // tempResult,currentQuestion,validation
  return (
    <MainTemplate
      content={
        <Switch>
          <div className="Module6test">
            <center><h6>Module 6 Test</h6></center>
            {showFinalResult ? (
              <div className="Final Result">
                <br/>
                <span className="align-right"> Question {currentQuestion + 1} out of {questions.length} </span>
             
                <br/>

                <div className="progress-bar">
                  <div className="progress" style={{ width: `${progress}%` }}>
                    {`${progress}% complete`}
                  </div>
                </div>
                <br/>

                <div class="card mt-4">
                 
                  <div class="card-body shadow" className={`${hasPass ? 'pass-card-border' : 'fail-card-border' }`}>
                     <h5> 
                      <center>
                        <img class="result" alt="result-picture" src={`${hasPass ? '/uploads/elearning/thumbs-up1.jpg' : '/uploads/elearning/thumbs-down.jpg' }`} /><br/>
                         <span>Here are your results: {score/10 * 100}% out of {questions.length/10 * 100}%</span><br/>
                         {/* <span class="score-text">Your Score : {score}</span> <br/>
                         <span class="score-text">Passing Score : {6}</span>  */}
                      </center>

                      
                      <br/>
                      { hasPass ? 
                      ( <div><center> Well Done!  <br/>  You have passed this test. </center></div>) 
                      : 
                      ( <div>
                          <center> 
                            Sorry!  <br/>  You have failed this test! You can retake the test when you are ready. <br/>
                            Go back to Main page to retake test.
                          </center>
                        </div>
                      ) }

                      <br/>
                      
                     </h5>

                     
                     
                     <center>
                    
                     <Link to="/module"> <button class="btn btn-primary">Main</button> </Link>
                     {/* { hasPass ? <Link to="/ECMS/module6"> <button  class="btn btn-info"> Next Test  </button> </Link> : '' } */}

                     </center> 
                  </div>

                </div>
                {/* <h1 >Final Result</h1>
                <h2>
                  {score} out of {questions.length} is correct-
                  {(score / questions.length) * 100}%
                </h2>
                <h3 className="Passfail">
                  {hasPass ? (
                    <h3>You Have pass your test</h3>
                  ) : (
                    <h3>You have failed your test</h3>
                  )}
                </h3> */}
               
                {/* {hasPass ?'': <button type="button" class="btn btn-primary float-right" onClick={() => submitClicked()}>SUBMIT</button> } */}
               
                {/* <button>Main page</button> */}
              </div>
            ) : (
              <div>
                <center>
                  <br/>
                  {videoPlay? ( 
                    // <div>
                    //     <ReactPlayer  url={samplevideo} width="100%" height="50%" controls={true}/> 
                    //     <button type="button" class="btn btn-info float-right" onClick={() => videoNextClicked()} >NEXT</button> 
                    // </div>
                    <div>
                      <ReactPlayer  url={samplevideo} width="70%" height="50%" controls={true}/> 
                      <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-4" style={{ paddingRight : 0 }}>
                            <button type="button" class="btn btn-info float-right" onClick={() => videoNextClicked()} >NEXT</button> 
                        </div>
                        <div class="col-md-2"></div>
                      </div>
                    </div>
                
                  ): 
                  (
                  <div>
                      <span className="align-right"> Question {currentQuestion + 1} out of {questions.length} </span>
                      <br/>

                      <div className="progress-bar">
                        <div className="progress" style={{ width: `${progress}%` }}>
                          {`${progress}% complete`}
                        </div>
                      </div>

                
                      <br/><br/>
                      <div className="qus-btn">
                        <h5 class="align-left">  
                              { showFinalResult ?  '' : questions[currentQuestion].test }
                        </h5>
                      </div>
                      <hr/>
                      <br/>
                      <div class="row">
                          {questions[currentQuestion].options.map((option) => {
                          
                            return (
                            
                                <div class="col-md-6 mb-4">
                                  
                                    <button  className={`button-option ${option.id === tempResult['qus'+currentQuestion] ? 'option-active' : '' }`} 
                                    // className="button-option"
                                        onClick={() => optionClicked(option.isCorrect,option.id,'qus'+currentQuestion)}
                                        key={option.id} 
                                    >
                                        <span class="align-left">{option.serial}</span>
                                        <span >{option.text}</span>
                                        
                                    </button>
                                </div>
                            );

                            return (
                              <row>
                                <col>
                                  <button className="button-52"
                                      onClick={() => optionClicked(option.isCorrect)}
                                      key={option.id} 
                                  >
                                      {option.text}
                                  </button>
                                </col>
                              </row>
                            );
                          })}
                      </div>

                      <div>
                        <button type="button" class="btn btn-info float-right" onClick={() => nextClicked()} disabled={validation} >NEXT</button>
                        <button type="button" class="btn btn-secondary float-right" onClick={() => backClicked()}>BACK</button>
                        {/* { count != 0 ?  <button type="button" class="btn btn-secondary float-right" onClick={() => backClicked()}>BACK</button> : ''} */}
                      </div>
                  </div>
                  )}
                </center>
              </div>
            )}
          </div>

          <Switch>
            {permission.add && <Route path="/:subdom/:page/:module6" />}
          </Switch>
        </Switch>
      }
    />
  );
}

export default Module6;



